import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Camera.module.scss";
import camera from "../../../../assets/images/cam.png";
import retakeImg from "../../../../assets/images/retake.png";
import { AvatarContext } from "../../../../contexts/AvatarContext/AvatarContextProvider";

const Camera = ({ handleSetImgSrc }) => {
  const [cameraNumber, setCameraNumber] = useState(0);
  const [imageDataURL, setImageDataURL] = useState(null);
  const player = useRef(null);
  const { state, handleScreen } = useContext(AvatarContext);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!state.cam_image && player.current !== null) {
      initializeMedia();
    }
  }, [state]);

  const initializeMedia = async () => {
    setImageDataURL(null);

    if (!("mediaDevices" in navigator)) {
      navigator.mediaDevices = {};
    }

    if (!("getUserMedia" in navigator.mediaDevices)) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        var getUserMedia =
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        if (!getUserMedia) {
          return Promise.reject(new Error("getUserMedia Not Implemented"));
        }

        return new Promise((resolve, reject) => {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }

    //Get the details of video inputs of the device
    const videoInputs = await getListOfVideoInputs();

    //The device has a camera
    if (videoInputs.length) {
      navigator.mediaDevices
        .getUserMedia({
          video: {
            deviceId: {
              exact: videoInputs[cameraNumber].deviceId,
            },
          },
        })
        .then((stream) => {
          player.current.srcObject = stream;
          setShowError(false);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      setShowError(true);
      alert("The device does not have a camera");
    }
  };

  const retakeImage = () => {
    setShowError(true);
    handleScreen("screen", "showCameraScreen");
    initializeMedia();
  };

  const capturePicture = () => {
    if (showError) {
      return;
    }
    var canvas = document.createElement("canvas");

    canvas.width = player.current.videoWidth;
    canvas.height = player.current.videoHeight;
    var contex = canvas.getContext("2d");
    contex.scale(-1, 1);
    contex.drawImage(player.current, 0, 0, canvas.width * -1, canvas.height);

    setImageDataURL(canvas.toDataURL());
    handleSetImgSrc(canvas.toDataURL());
    if (player.current.srcObject) {
      player.current.srcObject.getVideoTracks().forEach((track) => {
        track.stop();
      });
    }
    handleScreen("screen", "showRetakeScreen");
  };

  const switchCamera = async () => {
    const listOfVideoInputs = await getListOfVideoInputs();

    // The device has more than one camera
    if (listOfVideoInputs.length > 1) {
      if (player.current.srcObject) {
        player.current.srcObject.getVideoTracks().forEach((track) => {
          track.stop();
        });
      }
      let camNo = cameraNumber;
      // switch to second camera
      if (camNo === 0) {
        camNo = 1;
      }
      // switch to first camera
      else if (camNo === 1) {
        camNo = 0;
      }
      setCameraNumber(camNo);
      // Restart based on camera input
      initializeMedia();
    } else if (listOfVideoInputs.length === 1) {
      alert("The device has only one camera");
    } else {
      setShowError(true);
      alert("The device does not have a camera");
    }
  };

  const getListOfVideoInputs = async () => {
    // Get the details of audio and video output of the device
    const enumerateDevices = await navigator.mediaDevices.enumerateDevices();

    //Filter video outputs (for devices with multiple cameras)
    return enumerateDevices.filter((device) => device.kind === "videoinput");
  };

  const playerORImage =
    state.screen === "showRetakeScreen" ||
    state.screen === "showAvatarScreen" ||
    state.screen === "showProfileScreen" ? (
      <img
        src={state.cam_image ? state.cam_image : imageDataURL}
        alt="user"
        className={styles.clickedImage}
        height={"100%"}
        width={"100%"}
      />
    ) : (
      <video
        ref={(refrence) => {
          player.current = refrence;
        }}
        autoPlay
        playsinline
        controls={false}
        muted
        className={styles.screen}
        height={"100%"}
        width={"100%"}
      ></video>
    );

  return (
    <div className={styles.cameraWrapper}>
      <div className={styles.camera}>{playerORImage}</div>
      {state.screen !== "showAvatarScreen" &&
        state.screen !== "showProfileScreen" && (
          <img
            onClick={
              state.screen === "showRetakeScreen" ? retakeImage : capturePicture
            }
            className={styles.captureImg}
            src={state.screen === "showRetakeScreen" ? retakeImg : camera}
            alt="click"
          />
        )}

      {/* <button className={`btn ${styles.btn}`}>Capture</button> */}

      {/* <button onClick={initializeMedia}>Take Photo</button> */}
      {/* <button onClick={switchCamera}>Switch</button> */}
    </div>
  );
};

export default Camera;
